type Props = { width?: number; height?: number; fill?: string };
const RateIcon = ({ width = 40, height = 40, fill = "none" }: Props) => {
  return (
    <svg viewBox="0 0 128 128" width={width} height={height}>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#000000"
        stroke-opacity="0.00"
        stroke-width="0.3"
      >
        <path d="M 0.00 128.00 L 128.00 128.00 L 128.00 0.00 L 0.00 0.00 L 0.00 128.00 M 101.00 23.00 C 101.59 23.93 103.13 23.76 104.00 24.00 C 105.66 24.46 108.57 24.03 108.00 27.00 C 105.68 26.42 99.31 27.74 105.00 28.00 C 105.51 29.92 103.16 30.23 102.00 31.00 C 101.83 31.06 102.00 32.00 102.00 32.00 C 102.21 33.82 101.39 33.65 100.00 34.00 C 98.55 34.37 96.50 34.00 95.00 34.00 C 92.92 37.88 103.78 47.34 102.99 54.01 C 102.21 60.68 104.44 72.04 99.23 78.23 C 94.01 84.42 91.88 90.05 84.00 93.00 C 84.91 98.99 89.28 103.66 89.00 110.00 C 87.21 108.96 85.03 112.37 84.00 110.00 C 76.90 110.55 77.43 106.55 74.69 100.31 C 71.96 94.06 62.64 97.80 57.00 97.00 C 54.83 98.24 55.03 102.10 54.02 105.02 C 53.02 107.95 51.41 109.25 48.00 110.00 C 36.22 112.58 45.98 98.79 47.00 94.00 C 47.06 93.71 46.33 93.17 46.00 93.00 C 28.86 84.46 22.77 64.36 29.78 46.78 C 36.78 29.19 55.59 22.06 73.00 25.00 C 77.25 25.72 86.28 27.00 89.00 31.00 C 89.16 30.60 90.66 30.15 91.00 30.00 C 91.29 28.72 88.77 25.72 90.00 24.00 C 95.95 25.13 95.28 16.82 101.00 17.00 C 101.00 19.00 101.00 21.00 101.00 23.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#D76816"
        stroke-opacity="0.76"
        stroke-width="0.3"
      >
        <path d="M 91.00 30.00 C 92.11 29.50 93.76 29.79 94.00 28.00 C 93.16 26.60 92.93 23.97 94.00 27.00 C 96.39 25.33 97.94 22.28 101.00 24.00 C 100.31 28.10 96.16 30.62 94.00 34.00 C 94.50 34.00 95.00 34.00 95.00 34.00 C 96.50 34.00 98.55 34.37 100.00 34.00 C 99.16 33.74 99.67 31.34 100.00 31.00 C 100.60 30.39 101.56 29.42 102.00 31.00 C 103.16 30.23 105.51 29.92 105.00 28.00 C 99.31 27.74 105.68 26.42 108.00 27.00 C 108.57 24.03 105.66 24.46 104.00 24.00 C 102.85 23.72 102.32 25.50 101.00 23.00 C 101.00 21.00 101.00 19.00 101.00 17.00 C 95.28 16.82 95.95 25.13 90.00 24.00 C 88.77 25.72 91.29 28.72 91.00 30.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#FCC50B"
        stroke-opacity="0.99"
        stroke-width="0.3"
      >
        <path d="M 94.00 27.00 C 93.77 27.16 94.00 28.00 94.00 28.00 C 93.76 29.79 92.11 29.50 91.00 30.00 C 90.66 30.15 89.16 30.60 89.00 31.00 C 88.83 31.43 89.19 32.59 89.00 33.00 C 87.42 36.47 80.83 40.17 78.00 43.00 C 75.41 45.59 72.54 48.46 70.00 51.00 C 66.96 54.04 60.78 58.73 63.00 63.00 C 66.78 60.50 70.24 57.59 73.00 54.00 C 75.26 51.38 77.83 47.55 81.00 46.00 C 81.40 45.80 82.00 46.00 82.00 46.00 C 84.53 42.37 89.26 35.69 93.00 34.00 C 93.41 33.81 94.00 34.00 94.00 34.00 C 96.16 30.62 100.31 28.10 101.00 24.00 C 97.94 22.28 96.39 25.33 94.00 27.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#B64800"
        stroke-opacity="0.11"
        stroke-width="0.3"
      >
        <path d="M 104.00 24.00 C 103.13 23.76 101.59 23.93 101.00 23.00 C 102.32 25.50 102.85 23.72 104.00 24.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#E77724"
        stroke-opacity="0.96"
        stroke-width="0.3"
      >
        <path d="M 46.00 93.00 C 46.57 90.74 49.27 93.43 47.00 94.00 C 45.98 98.79 36.22 112.58 48.00 110.00 C 51.03 107.07 49.08 98.09 53.00 95.00 C 54.05 96.37 56.44 95.23 57.00 97.00 C 62.64 97.80 71.96 94.06 74.69 100.31 C 77.43 106.55 76.90 110.55 84.00 110.00 C 81.01 106.41 83.60 96.57 79.00 93.00 C 86.30 89.71 89.12 85.31 93.92 78.92 C 98.72 72.53 99.02 62.59 98.22 54.78 C 97.42 46.96 90.16 40.47 93.00 34.00 C 89.26 35.69 84.53 42.37 82.00 46.00 C 86.17 50.77 88.47 60.38 86.67 66.67 C 84.87 72.96 80.95 77.47 75.25 81.25 C 69.55 85.03 60.69 85.33 53.99 83.01 C 47.29 80.69 44.72 75.91 41.08 69.92 C 37.44 63.93 39.86 54.44 42.77 48.77 C 45.68 43.10 52.93 38.88 57.67 37.67 C 62.41 36.46 77.79 36.65 78.00 43.00 C 80.83 40.17 87.42 36.47 89.00 33.00 C 86.88 35.68 75.34 25.94 73.00 25.00 C 55.59 22.06 36.78 29.19 29.78 46.78 C 22.77 64.36 28.86 84.46 46.00 93.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#B84902"
        stroke-opacity="0.77"
        stroke-width="0.3"
      >
        <path d="M 89.00 33.00 C 89.19 32.59 88.83 31.43 89.00 31.00 C 86.28 27.00 77.25 25.72 73.00 25.00 C 75.34 25.94 86.88 35.68 89.00 33.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#B64701"
        stroke-opacity="0.99"
        stroke-width="0.3"
      >
        <path d="M 94.00 28.00 C 94.00 28.00 93.77 27.16 94.00 27.00 C 92.93 23.97 93.16 26.60 94.00 28.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#BC4D02"
        stroke-opacity="0.17"
        stroke-width="0.3"
      >
        <path d="M 100.00 31.00 C 100.12 31.50 101.50 32.53 102.00 32.00 C 102.00 32.00 101.83 31.06 102.00 31.00 C 101.56 29.42 100.60 30.39 100.00 31.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#BD4E05"
        stroke-opacity="0.44"
        stroke-width="0.3"
      >
        <path d="M 100.00 34.00 C 101.39 33.65 102.21 33.82 102.00 32.00 C 101.50 32.53 100.12 31.50 100.00 31.00 C 99.67 31.34 99.16 33.74 100.00 34.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#B74801"
        stroke-opacity="0.85"
        stroke-width="0.3"
      >
        <path d="M 84.00 110.00 C 85.03 112.37 87.21 108.96 89.00 110.00 C 89.28 103.66 84.91 98.99 84.00 93.00 C 91.88 90.05 94.01 84.42 99.23 78.23 C 104.44 72.04 102.21 60.68 102.99 54.01 C 103.78 47.34 92.92 37.88 95.00 34.00 C 95.00 34.00 94.50 34.00 94.00 34.00 C 94.00 34.00 93.41 33.81 93.00 34.00 C 90.16 40.47 97.42 46.96 98.22 54.78 C 99.02 62.59 98.72 72.53 93.92 78.92 C 89.12 85.31 86.30 89.71 79.00 93.00 C 83.60 96.57 81.01 106.41 84.00 110.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#FEFCFB"
        stroke-opacity="1.00"
        stroke-width="0.3"
      >
        <path d="M 82.00 46.00 C 82.00 46.00 81.40 45.80 81.00 46.00 C 78.88 49.03 75.91 51.85 73.00 54.00 C 76.01 58.11 75.68 63.86 72.75 67.75 C 69.81 71.63 65.78 73.80 60.78 72.22 C 55.78 70.64 53.02 69.00 51.68 63.32 C 50.34 57.65 52.42 55.63 56.23 51.23 C 60.04 46.84 66.26 51.49 70.00 51.00 C 72.54 48.46 75.41 45.59 78.00 43.00 C 77.79 36.65 62.41 36.46 57.67 37.67 C 52.93 38.88 45.68 43.10 42.77 48.77 C 39.86 54.44 37.44 63.93 41.08 69.92 C 44.72 75.91 47.29 80.69 53.99 83.01 C 60.69 85.33 69.55 85.03 75.25 81.25 C 80.95 77.47 84.87 72.96 86.67 66.67 C 88.47 60.38 86.17 50.77 82.00 46.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#FEECA5"
        stroke-opacity="1.00"
        stroke-width="0.3"
      >
        <path d="M 73.00 54.00 C 75.91 51.85 78.88 49.03 81.00 46.00 C 77.83 47.55 75.26 51.38 73.00 54.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#E87A29"
        stroke-opacity="1.00"
        stroke-width="0.3"
      >
        <path d="M 73.00 54.00 C 70.24 57.59 66.78 60.50 63.00 63.00 C 60.78 58.73 66.96 54.04 70.00 51.00 C 66.26 51.49 60.04 46.84 56.23 51.23 C 52.42 55.63 50.34 57.65 51.68 63.32 C 53.02 69.00 55.78 70.64 60.78 72.22 C 65.78 73.80 69.81 71.63 72.75 67.75 C 75.68 63.86 76.01 58.11 73.00 54.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#E87722"
        stroke-opacity="0.71"
        stroke-width="0.3"
      >
        <path d="M 46.00 93.00 C 46.33 93.17 47.06 93.71 47.00 94.00 C 49.27 93.43 46.57 90.74 46.00 93.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#B74901"
        stroke-opacity="0.85"
        stroke-width="0.3"
      >
        <path d="M 48.00 110.00 C 51.41 109.25 53.02 107.95 54.02 105.02 C 55.03 102.10 54.83 98.24 57.00 97.00 C 56.44 95.23 54.05 96.37 53.00 95.00 C 49.08 98.09 51.03 107.07 48.00 110.00 Z" />
      </g>
      <g fill="#000000" fill-opacity="0.00" stroke="None">
        <path d="M 0.00 128.00 L 128.00 128.00 L 128.00 0.00 L 0.00 0.00 L 0.00 128.00 M 101.00 23.00 C 101.59 23.93 103.13 23.76 104.00 24.00 C 105.66 24.46 108.57 24.03 108.00 27.00 C 105.68 26.42 99.31 27.74 105.00 28.00 C 105.51 29.92 103.16 30.23 102.00 31.00 C 101.83 31.06 102.00 32.00 102.00 32.00 C 102.21 33.82 101.39 33.65 100.00 34.00 C 98.55 34.37 96.50 34.00 95.00 34.00 C 92.92 37.88 103.78 47.34 102.99 54.01 C 102.21 60.68 104.44 72.04 99.23 78.23 C 94.01 84.42 91.88 90.05 84.00 93.00 C 84.91 98.99 89.28 103.66 89.00 110.00 C 87.21 108.96 85.03 112.37 84.00 110.00 C 76.90 110.55 77.43 106.55 74.69 100.31 C 71.96 94.06 62.64 97.80 57.00 97.00 C 54.83 98.24 55.03 102.10 54.02 105.02 C 53.02 107.95 51.41 109.25 48.00 110.00 C 36.22 112.58 45.98 98.79 47.00 94.00 C 47.06 93.71 46.33 93.17 46.00 93.00 C 28.86 84.46 22.77 64.36 29.78 46.78 C 36.78 29.19 55.59 22.06 73.00 25.00 C 77.25 25.72 86.28 27.00 89.00 31.00 C 89.16 30.60 90.66 30.15 91.00 30.00 C 91.29 28.72 88.77 25.72 90.00 24.00 C 95.95 25.13 95.28 16.82 101.00 17.00 C 101.00 19.00 101.00 21.00 101.00 23.00 Z" />
      </g>
      <g fill="#D76816" fill-opacity="0.76" stroke="None">
        <path d="M 91.00 30.00 C 92.11 29.50 93.76 29.79 94.00 28.00 C 93.16 26.60 92.93 23.97 94.00 27.00 C 96.39 25.33 97.94 22.28 101.00 24.00 C 100.31 28.10 96.16 30.62 94.00 34.00 C 94.50 34.00 95.00 34.00 95.00 34.00 C 96.50 34.00 98.55 34.37 100.00 34.00 C 99.16 33.74 99.67 31.34 100.00 31.00 C 100.60 30.39 101.56 29.42 102.00 31.00 C 103.16 30.23 105.51 29.92 105.00 28.00 C 99.31 27.74 105.68 26.42 108.00 27.00 C 108.57 24.03 105.66 24.46 104.00 24.00 C 102.85 23.72 102.32 25.50 101.00 23.00 C 101.00 21.00 101.00 19.00 101.00 17.00 C 95.28 16.82 95.95 25.13 90.00 24.00 C 88.77 25.72 91.29 28.72 91.00 30.00 Z" />
      </g>
      <g fill="#FCC50B" fill-opacity="0.99" stroke="None">
        <path d="M 94.00 27.00 C 93.77 27.16 94.00 28.00 94.00 28.00 C 93.76 29.79 92.11 29.50 91.00 30.00 C 90.66 30.15 89.16 30.60 89.00 31.00 C 88.83 31.43 89.19 32.59 89.00 33.00 C 87.42 36.47 80.83 40.17 78.00 43.00 C 75.41 45.59 72.54 48.46 70.00 51.00 C 66.96 54.04 60.78 58.73 63.00 63.00 C 66.78 60.50 70.24 57.59 73.00 54.00 C 75.26 51.38 77.83 47.55 81.00 46.00 C 81.40 45.80 82.00 46.00 82.00 46.00 C 84.53 42.37 89.26 35.69 93.00 34.00 C 93.41 33.81 94.00 34.00 94.00 34.00 C 96.16 30.62 100.31 28.10 101.00 24.00 C 97.94 22.28 96.39 25.33 94.00 27.00 Z" />
      </g>
      <g fill="#B64800" fill-opacity="0.11" stroke="None">
        <path d="M 104.00 24.00 C 103.13 23.76 101.59 23.93 101.00 23.00 C 102.32 25.50 102.85 23.72 104.00 24.00 Z" />
      </g>
      <g fill="#E77724" fill-opacity="0.96" stroke="None">
        <path d="M 46.00 93.00 C 46.57 90.74 49.27 93.43 47.00 94.00 C 45.98 98.79 36.22 112.58 48.00 110.00 C 51.03 107.07 49.08 98.09 53.00 95.00 C 54.05 96.37 56.44 95.23 57.00 97.00 C 62.64 97.80 71.96 94.06 74.69 100.31 C 77.43 106.55 76.90 110.55 84.00 110.00 C 81.01 106.41 83.60 96.57 79.00 93.00 C 86.30 89.71 89.12 85.31 93.92 78.92 C 98.72 72.53 99.02 62.59 98.22 54.78 C 97.42 46.96 90.16 40.47 93.00 34.00 C 89.26 35.69 84.53 42.37 82.00 46.00 C 86.17 50.77 88.47 60.38 86.67 66.67 C 84.87 72.96 80.95 77.47 75.25 81.25 C 69.55 85.03 60.69 85.33 53.99 83.01 C 47.29 80.69 44.72 75.91 41.08 69.92 C 37.44 63.93 39.86 54.44 42.77 48.77 C 45.68 43.10 52.93 38.88 57.67 37.67 C 62.41 36.46 77.79 36.65 78.00 43.00 C 80.83 40.17 87.42 36.47 89.00 33.00 C 86.88 35.68 75.34 25.94 73.00 25.00 C 55.59 22.06 36.78 29.19 29.78 46.78 C 22.77 64.36 28.86 84.46 46.00 93.00 Z" />
      </g>
      <g fill="#B84902" fill-opacity="0.77" stroke="None">
        <path d="M 89.00 33.00 C 89.19 32.59 88.83 31.43 89.00 31.00 C 86.28 27.00 77.25 25.72 73.00 25.00 C 75.34 25.94 86.88 35.68 89.00 33.00 Z" />
      </g>
      <g fill="#B64701" fill-opacity="0.99" stroke="None">
        <path d="M 94.00 28.00 C 94.00 28.00 93.77 27.16 94.00 27.00 C 92.93 23.97 93.16 26.60 94.00 28.00 Z" />
      </g>
      <g fill="#BC4D02" fill-opacity="0.17" stroke="None">
        <path d="M 100.00 31.00 C 100.12 31.50 101.50 32.53 102.00 32.00 C 102.00 32.00 101.83 31.06 102.00 31.00 C 101.56 29.42 100.60 30.39 100.00 31.00 Z" />
      </g>
      <g fill="#BD4E05" fill-opacity="0.44" stroke="None">
        <path d="M 100.00 34.00 C 101.39 33.65 102.21 33.82 102.00 32.00 C 101.50 32.53 100.12 31.50 100.00 31.00 C 99.67 31.34 99.16 33.74 100.00 34.00 Z" />
      </g>
      <g fill="#B74801" fill-opacity="0.85" stroke="None">
        <path d="M 84.00 110.00 C 85.03 112.37 87.21 108.96 89.00 110.00 C 89.28 103.66 84.91 98.99 84.00 93.00 C 91.88 90.05 94.01 84.42 99.23 78.23 C 104.44 72.04 102.21 60.68 102.99 54.01 C 103.78 47.34 92.92 37.88 95.00 34.00 C 95.00 34.00 94.50 34.00 94.00 34.00 C 94.00 34.00 93.41 33.81 93.00 34.00 C 90.16 40.47 97.42 46.96 98.22 54.78 C 99.02 62.59 98.72 72.53 93.92 78.92 C 89.12 85.31 86.30 89.71 79.00 93.00 C 83.60 96.57 81.01 106.41 84.00 110.00 Z" />
      </g>
      <g fill="#FEFCFB" fill-opacity="1.00" stroke="None">
        <path d="M 82.00 46.00 C 82.00 46.00 81.40 45.80 81.00 46.00 C 78.88 49.03 75.91 51.85 73.00 54.00 C 76.01 58.11 75.68 63.86 72.75 67.75 C 69.81 71.63 65.78 73.80 60.78 72.22 C 55.78 70.64 53.02 69.00 51.68 63.32 C 50.34 57.65 52.42 55.63 56.23 51.23 C 60.04 46.84 66.26 51.49 70.00 51.00 C 72.54 48.46 75.41 45.59 78.00 43.00 C 77.79 36.65 62.41 36.46 57.67 37.67 C 52.93 38.88 45.68 43.10 42.77 48.77 C 39.86 54.44 37.44 63.93 41.08 69.92 C 44.72 75.91 47.29 80.69 53.99 83.01 C 60.69 85.33 69.55 85.03 75.25 81.25 C 80.95 77.47 84.87 72.96 86.67 66.67 C 88.47 60.38 86.17 50.77 82.00 46.00 Z" />
      </g>
      <g fill="#FEECA5" fill-opacity="1.00" stroke="None">
        <path d="M 73.00 54.00 C 75.91 51.85 78.88 49.03 81.00 46.00 C 77.83 47.55 75.26 51.38 73.00 54.00 Z" />
      </g>
      <g fill="#E87A29" fill-opacity="1.00" stroke="None">
        <path d="M 73.00 54.00 C 70.24 57.59 66.78 60.50 63.00 63.00 C 60.78 58.73 66.96 54.04 70.00 51.00 C 66.26 51.49 60.04 46.84 56.23 51.23 C 52.42 55.63 50.34 57.65 51.68 63.32 C 53.02 69.00 55.78 70.64 60.78 72.22 C 65.78 73.80 69.81 71.63 72.75 67.75 C 75.68 63.86 76.01 58.11 73.00 54.00 Z" />
      </g>
      <g fill="#E87722" fill-opacity="0.71" stroke="None">
        <path d="M 46.00 93.00 C 46.33 93.17 47.06 93.71 47.00 94.00 C 49.27 93.43 46.57 90.74 46.00 93.00 Z" />
      </g>
      <g fill="#B74901" fill-opacity="0.85" stroke="None">
        <path d="M 48.00 110.00 C 51.41 109.25 53.02 107.95 54.02 105.02 C 55.03 102.10 54.83 98.24 57.00 97.00 C 56.44 95.23 54.05 96.37 53.00 95.00 C 49.08 98.09 51.03 107.07 48.00 110.00 Z" />
      </g>
    </svg>
  );
};
export default RateIcon;
